<template>
  <v-container class="mt-16">   
    <v-dialog v-model="addBannerDialog" persistent max-width="750px">
      <v-card>
        <v-toolbar flat color='primary'>         
        <v-toolbar-title>{{  banner?.id ? 'EDIT':'ADD NEW'}} BANNER</v-toolbar-title>
        <v-spacer></v-spacer>   
          <v-hover>
              <template v-slot:default="{ hover }">
              <v-btn 
                icon 
                @click="closeBannerDialog" 
                :color="hover ? 'red' : 'default'"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              </template>
          </v-hover>
        </v-toolbar>
        <v-form ref="bannerForm" v-model="valid"> 
          <v-card-text>          
            <v-row>
              <v-col cols="12" sm="6">
                <v-select :items="companies" v-model="banner.Company" label="Company"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select :items="categories" v-model="banner.Category" label="Category"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
              <v-text-field 
              v-model="banner.title" 
              clearable label="Title" 
              >
              //:rules="titleRules"
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-textarea  
              v-model="banner.Message" 
              auto-grow rows="2" 
              clearable label="Message"             
              >
              //:rules="messageRules"
              </v-textarea>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field 
                v-model="banner.innerroute" 
                label="Inner Route" 
                > //:rules="linkRules"
                </v-text-field>
                <v-text-field 
                v-model="banner.src" 
                label="Image Link" 
                >
                //:rules="linkRules"
                </v-text-field>
                <v-file-input
                  label="Upload Image"
                  prepend-icon="mdi-camera"
                  v-model="file"
                  :rules="fileRules"
                  @change="previewImage"
                  accept="image/*"
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="6">                
                <v-img 
                  :src="imageUrl" 
                  contain
                  outlined
                  height="200" 
                  max-width="500" 
                  >
                  <!-- v-if="imageUrl" -->
                  <!-- isImageuploading -->
                  <template v-slot:placeholder>
                  <!-- <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  > -->
                  <v-skeleton-loader
                    class="mx-auto"
                    contain
                    height="200" 
                    max-width="500"
                    type="card"
                  ></v-skeleton-loader>
                    <!-- <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular> -->
                  <!-- </v-row> -->
                </template>
                </v-img>                
              </v-col>
            </v-row>  
            <!-- <v-combobox
              v-model="tagModel"
              :items="tagOptions"
              :search-input.sync="tagSearch"
              hide-selected
              hint="Maximum of 5 tags"
              label="Add tags to your banner"
              multiple
              persistent-hint
              small-chips
              attach
              clearable
              @keyup.enter="addTag" 
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      No results matching "<strong>{{ tagSearch }}</strong>". Press <kbd>enter</kbd> to create a new one.
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>   -->
           <v-combobox
            v-model="tagModel"
            :filter="filter"
            :hide-no-data="!search"
            :items="items"
            :search-input.sync="search"
            hide-selected
            label="Add tags to your banner"
            multiple
            small-chips
            hint="Like emp code, name , desg , dep. (Max of 5 tags)"
            persistent-hint
          >
            <template v-slot:no-data>
              <v-list-item>
                <span class="subheading">Create</span>
                <v-chip
                  :color="`${colors[nonce - 1]} lighten-3`"
                  label
                  small
                >
                  {{ search }}
                </v-chip>
              </v-list-item>
            </template>
            <template v-slot:selection="{ attrs, item, parent, selected }">
              <v-chip
                v-if="item === Object(item)"
                v-bind="attrs"
                :color="`${item.color} lighten-3`"
                :input-value="selected"
                label
                small
              >
                <span class="pr-2">
                  {{ item.text }}
                </span>
                <v-icon
                  small
                  @click="parent.selectItem(item)"
                >
                  $delete
                </v-icon>
              </v-chip>
            </template>
            <template v-slot:item="{ index, item }">
              <v-text-field
                v-if="editing === item"
                v-model="editing.text"
                autofocus
                flat
                background-color="transparent"
                hide-details
                solo
                @keyup.enter="edit(index, item)"
              ></v-text-field>
              <v-chip
                v-else
                :color="`${item.color} lighten-3`"
                dark
                label
                small
              >
                {{ item.text }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-list-item-action @click.stop>
                <v-btn
                  icon
                  @click.stop.prevent="edit(index, item)"
                >
                  <v-icon>{{ editing !== item ? 'mdi-pencil' : 'mdi-check' }}</v-icon>
                </v-btn>
              </v-list-item-action>
            </template>
          </v-combobox>
                
            <!-- here banner.isActive is the key to be poaased to fire based db , but another thing is that
            if  Scheduled then  then  banner.isActive is also true or else if v-radio label="Enabled" the also true finally user can set false-->
            <v-row>
              <v-col cols="6">
                <v-radio-group v-model="banner.isActive" row>
                  <v-radio label="Enabled" :value="true"></v-radio>
                  <v-radio label="Disabled" :value="false"></v-radio>
                  <!-- <v-radio label="Scheduled" :value="true"></v-radio>     -->
                </v-radio-group>
              </v-col>
              <v-col cols="6">
                <v-switch
                  v-model="isScheduled"
                  inset
                  :label="`Scheduled: ${isScheduled.toString()}`"
                ></v-switch>
              </v-col>
          </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="fromDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFrom"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="isScheduled ? [v => !!v || 'From date is required', dateNotInPast] : []"
                    ></v-text-field>                    
                  </template>
                  <v-date-picker
                    v-model="dateFrom"
                    @input="fromDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="fromTimeMenu"
                  v-model="fromTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="fromTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromTime"
                      label="From Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="isScheduled ? [v => !!v || 'From time is required'] : []"
                    ></v-text-field>
                    <!-- if isScheduled is true then only 'From time is required' also should be before to time  on that day --> 
                  </template>
                  <v-time-picker
                    v-if="fromTimeMenu"
                    v-model="fromTime"
                    full-width
                    format="24hr"
                    @click:minute="$refs.fromTimeMenu.save(fromTime)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="toDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateTill"
                      label="To Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="isScheduled ? [v => !!v || 'To date is required', dateAfterFromDate] : []"
                    ></v-text-field>
                    <!-- :rules="[v => !!v || 'To date is required']" -->
                    <!-- if isScheduled is true then only  'From date is required' also should be after from date and not to be past dates from today -->
                  </template>
                  <v-date-picker
                    v-model="dateTill"
                    @input="toDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="toTimeMenu"
                  v-model="toTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="toTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toTime"
                      label="To Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="isScheduled ? [v => !!v || 'To time is required', timeAfterFromTime] : []"
                    ></v-text-field>
                      <!-- if isScheduled is true then only 'To time is required' also should be after from date time  on that previous day --> 
                  </template>
                  <v-time-picker
                    v-if="toTimeMenu"
                    v-model="toTime"
                    format="24hr"
                    full-width
                    @click:minute="$refs.toTimeMenu.save(toTime)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>

          <v-overlay :value="isSaving">
            <v-progress-linear
              v-if="banner?.isImageuploading"
              v-model="imageUploadingProgress"
              height="25"
            >
              <strong>Image Uploading{{ Math.ceil(imageUploadingProgress) }}%</strong>
            </v-progress-linear>
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-card-text>      
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeBannerDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="submitBanner">Save</v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>

    <v-data-table :headers="headers" :items="banners" class="elevation-1">
      <template v-slot:top>
      <v-toolbar flat>        
      <v-toolbar-title>Banners</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>        
        <v-btn fab small icon color="primary" @click="fetchAllBanner"  >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>     
        <v-spacer></v-spacer>   
        <v-btn color="primary" @click="newBanner()">Add New</v-btn>
      </v-toolbar>
      </template>
      <template v-slot:item.title="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            {{ truncateText(item?.title, 50) }}
          </span>
        </template>
        <span>{{ item?.title }}</span>
      </v-tooltip>
    </template>

    <template v-slot:item.Message="{ item }">
      <div>
        {{ truncateText(item?.Message, 50) }}
        <v-btn
          v-if="item?.Message?.length > 100"
          x-small
          text
          color="primary"
          @click="showFullMessage(item)"
        >
          Show more
        </v-btn>
      </div>
    </template>
      <template v-slot:item.tags="{ item }">
        <v-chip
          v-for="tag in item.tags"
          :key="tag"
          class="mr-1"
          small
          color='primary darken-3'
          outlined          
        >
          {{ tag }}
        </v-chip>
    </template>
      <template v-slot:item.src="{ item }">
        <v-layout align-center justify-center>
          <v-img 
            :src="item.src" 
            height="50" 
            width="10" 
            contain
            @click="showFullImage(item.src)"
            class="cursor-pointer"
          ></v-img>
        </v-layout>        
      </template>
      <template v-slot:item.validFrom="{ item }">
        {{ formatDateTime(item.validFrom) }}
      </template>
      <template v-slot:item.validTill="{ item }">
        {{ formatDateTime(item.validTill) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table> 
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      isSaving: false,
      addBannerDialog: false,
      isScheduled:false,
      isContinuous:false,
      valid: true,
      fromDateMenu: false,
      fromTimeMenu: false,
      toDateMenu: false,
      toTimeMenu: false,
      menuFrom:false,
      menuTill:false,
      date: '',
      time: '',
      timeFrom: false,
      timeTill: false,
      file: null,
      imageUrl: null,
      activator: null,
      attach: null,
      colors: ['green', 'purple', 'indigo', 'cyan', 'teal', 'orange'],
      editing: null,
      editingIndex: -1,
      items: [
        { header: 'Select an tag or type and enter to create one' }, 
      ],
      nonce: 1,
      tagModel:[],
      x: 0,
      search: null,
      y: 0,
      dateFrom: null,
      dateTill: null,
      fromTime:null,
      toTime:null,
      banner: {
        title: "",
        Message: "",
        src: "",
        innerroute:"",
        Company: "All",
        Category: "", 
        isActive: false, // optional if  validFrom , validTill is there
        validFrom: "" , //  date and time validFrom should be before  validTill
        validTill: "", //  date and time optional if  isActive is True
        createdby: this.fbuser?.uid,
        createdbyName: this.fbuserdata?.firstname ,
        createdAt:  new Date().toISOString(),
        groupNo: 0, // default 1
        // tags: null,        
        isImageuploading: false,
      },
      imageUploadingProgress:0,
      companies: ['All', 'Skymat', 'Triton'],
      categories: ['Common', 'Monthly', 'Notification', 'Birthday','Editorial'],
      tagOptions: [], // Predefined tags
      tagSearch: null, // For the search input of tags
      headers: [
        { text: 'Title', value: 'title' },
        { text: 'Message', value: 'Message' },
        { text: 'Image', value: 'src',width: '5%' , sortable: false, align: 'center'  },
        { text: 'Internal', value: 'innerroute',width: '5%' , sortable: false, align: 'center'  },
        { text: 'Company', value: 'Company' },
        { text: 'Category', value: 'Category' },
        { text: 'Status', value: 'isActive'},
        { text: 'Tags', value: 'tags'},        
        { text: 'validFrom', value:'validFrom' },
        { text: 'validTill', value:'validTill' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],  
      
      titleRules: [v => !!v || 'Title is required'],
      messageRules: [v => !!v || 'Message is required'],
      linkRules: [v => !!v || 'Link is required'],
      fileRules: [v => !v|| v.size < 2000000 || 'Image size should be less than 2 MB',],
    };
  },
  watch: {
    'banner.tags': function (newTags) {
      if (newTags && newTags.length > 5) {
        this.$nextTick(() => {
          // Only keep the first five tags
          this.banner.tags = newTags.slice(0, 5);
        });
      }
    },   
    tagModel (val, prev) {
      if (val.length === prev.length) return

      this.tagModel = val.map(v => {
        if (typeof v === 'string') {
          v = {
            text: v,
            color: this.colors[this.nonce - 1],
          }

          this.items.push(v)

          this.nonce++
        }

        return v
      })
    },
  },
  computed: {   
    banners(){
       return this.$store.getters.allBanners
    },
    fbuser(){     
      return this.$store.getters.fbuser;     //fbuser.uid  
    },
    fbuserdata(){      
      return this.$store.getters.fbuserdata;     //fbuserdata.firstname 
    },
    formattedValidFrom: {
      get() {
        if (!this.banner.validFrom) return '';
        return this.formatDate(this.banner.validFrom);
      },
      set(newValue) {
        this.banner.validFrom = this.parseDate(newValue);
      }
    },
    formattedValidTill: {
      get() {
        if (!this.banner.validTill) return '';
        return this.formatDate(this.banner.validTill);
      },
      set(newValue) {
        this.banner.validTill = this.parseDate(newValue);
      }
    }
  },
  methods: {
    addTag() {
      const newTag = this.tagSearch ? this.tagSearch.trim() : '';  // Use an empty string as a fallback
      if (newTag && !this.tagOptions.includes(newTag)) {
        this.tagOptions.push(newTag);
      }
      if (newTag && !this.banner.tags.includes(newTag)) {
        if (this.banner.tags.length < 5) {
          this.banner.tags.push(newTag);
        } else {
          this.$toast.warn('You can only add up to 5 tags.'); // Replace with a more appropriate notification
        }
      }
      this.tagSearch = null;  // Reset to empty string after adding
    },
    startEdit(index, item) {
      if (this.editing === item) {
        this.finishEdit(index, item)
      } else {
        this.editing = item
      }
    },
    finishEdit(index, item) {
      if (this.editing === item) {
        this.$set(this.banner.tags, index, JSON.parse(JSON.stringify(this.editing)))
        this.editing = null
      }
    },
    edit (index, item) {
      if (!this.editing) {
        this.editing = item
        this.editingIndex = index
      } else {
        this.editing = null
        this.editingIndex = -1
      }
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => val != null ? val : ''

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    },

    handleDateTimeChange(field, date, time) {
      const fullDateTime = new Date(`${date}T${time}`);
      this.banner[field] = fullDateTime.toISOString();      
      this[field === 'from' ? 'menuFrom' : 'menuTill'] = false;
      this[field === 'from' ? 'timeFrom' : 'timeTill'] = false; // Reset time picker visibility
    },   
    
    newBanner() {
      this.resetForm();
      this.addBannerDialog = true;
    },
    closeBannerDialog() {
      this.resetForm();
      this.addBannerDialog = false;
    },    
    previewImage() {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageUrl = e.target.result;
      };
      reader.readAsDataURL(this.file);
    },
    async uploadImageToFirebase() {
      console.log(this.file)
      if (this.file) {
        try {
          const metadata = {
            customMetadata: {
              uploadedBy: this.fbuser?.uid,
              uploadTime: new Date().toISOString(),
              tags: JSON.stringify(this.banner.tags), // Storing tags as a JSON string
            }
          };
          const storageRef = this.$fbStorage.ref(`${this.banner.Category}/${this.file.name}`);
          const uploadTask = storageRef.put(this.file,metadata);

          await new Promise((resolve, reject) => {
            uploadTask.on('state_changed', 
              (snapshot) => {
                // Optionally handle progress updates here if needed
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                this.imageUploadingProgress = progress;
                console.log('Upload is ' + progress + '% done');
              }, 
              (error) => {
                console.error("Upload failed:", error);
                reject(error);  // Reject the promise on error
              }, 
              () => {
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                  console.log('File available at', downloadURL);
                  this.banner.src = downloadURL; // Set the banner src to the download URL
                  this.banner.imageMetadata = uploadTask.snapshot.metadata.customMetadata;
                  resolve();  // Resolve the promise when the URL is obtained
                });
              }
            );
          });

        } catch (error) {
          console.error("An error occurred during the upload:", error);
        }
      }
    },
    
    async submitBanner() {
      if (this.$refs.bannerForm.validate()) {
        this.isSaving = true;
        try {
          await this.uploadImageToFirebase(); // Wait for the image upload to complete
          let banner = { ...this.banner };
              banner.tags = [...new Set(this.tagModel.map(tag => tag.text))];

              banner.validFrom = this.isScheduled? new Date(`${this.dateFrom}T${this.fromTime}`).toISOString() :'';
              banner.validTill = this.isScheduled? new Date(`${this.dateTill}T${this.toTime}`).toISOString():''; 
              
          //     if (banner.id) {
          //   // Existing banner, update it
          //   await this.$store.dispatch("updateBanner", { bannerId: this.banner.id, updatedBanner: banner });
          // } else {
          //   // New banner, add it
          //   await this.$store.dispatch("addBanner", banner);
          // }
          this.closeBannerDialog();
          this.resetForm();
        } catch (error) {
          console.error("Failed to submit the banner:", error);
        }
        this.isSaving = false;
      }
    },
    fetchAllBanner(){
      this.$store.dispatch("getAllBanners")
    },
    editItem(item) {
      // console.log(item)
      this.file = null;
      this.imageUrl = item?.src;
      this.tagModel=item.tags;
      Object.assign(this.banner, item); // Cloning item to avoid direct mutation
      this.dateFrom = item?.validFrom;
      this.dateTill= item?.validFrom;
      this.fromTime = item?.toFrom;
      this.toTime=item?.toFrom;
      this.addBannerDialog = true;
    },
    async deleteItem(item) {
      try {
          const result = await this.$swal({
              title: 'Are you sure?',
              text: 'You will not be able to recover this Banner!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!'
          });

          if (result.isConfirmed) {      
          this.$store.dispatch("deleteBanner", item.id);
          }
      } catch (error) {
          console.error('Deletion error:', error);              
          this.$toast.error("An error occurred during deletion.");
      }
    },
    resetForm() {
      this.banner = {
        title: "",
        Message: "",
        src: "",
        innerroute: "",
        Company: "All",
        Category: "",
        isActive: false,
        validFrom: "",
        validTill: "",
        createdby: this.fbuser?.uid,
        createdbyName: this.fbuserdata?.firstname,
        createdAt: new Date().toISOString(),
        groupNo: 1
      };    
      this.file = null; 
      this.imageUrl = null;
      this.tagModel = [];
      this.dateFrom =  null;
      this.dateTill= null;
      this.fromTime=null;
      this.toTime=null;
      // this.$refs.bannerForm.resetValidation();
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleString("en-US", {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
      });
    },
    parseDate(datetimeStr) {
      // This assumes datetimeStr is a full datetime ISO string from user input
      return new Date(datetimeStr).toISOString();
    },
    formatDateTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp.seconds * 1000);
      return date.toLocaleDateString("en-US", {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
    },
    dateNotInPast(v) {
      return new Date(v) >= new Date().setHours(0,0,0,0) || 'Date cannot be in the past'
    },
    dateAfterFromDate(v) {
      return new Date(v) >= new Date(this.dateFrom) || 'To date must be after or equal to From date'
    },
    timeAfterFromTime() {
      if (this.dateFrom === this.dateTill) {
        return this.toTime > this.fromTime || 'To time must be after From time on the same day'
      }
      return true
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    },
    showFullMessage(item) {
      this.$swal.fire({
        title: item.title,
        text:  item.Message,
        confirmButtonText: 'Close'
      });
    },
    showFullImage(src) {
      this.$swal.fire({
        imageUrl: src,
        imageAlt: 'Full size image',
        imageWidth: '100%',
        imageHeight: 'auto',
        showCloseButton: true,
        showConfirmButton: false,
        background: 'primary lighten-2',
        padding: '10px',
      });
    }
  },
  created(){
    // this.$store.dispatch("getSalesPersons", { smandocno: this.usersperson })
    this.fetchAllBanner();
  }
  
};

</script>
 
